import React, {ChangeEvent} from "react"
import styles from "./radiobutton.module.scss"
import {TextMessage} from "../text/text"
import {ValidationResult} from "../../util/validation/validation-result"

export interface RadioButtonProperties {
  checked?: boolean
  disabled?: boolean
  personalData?: boolean
  name: string
  value: string
  label: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  readonly showValidity?: boolean
  readonly validationResult?: ValidationResult
}
export const RadioButton: React.FC<RadioButtonProperties> = ({checked = false, disabled = false,
  personalData = false, name, value, label, onChange, validationResult, showValidity = false}) => {

  const labelClass = (showValidity && validationResult !== undefined && !validationResult.valid)
    ? styles.LabelFieldError
    : styles.LabelField

  return <label>
    <input checked={checked} disabled={disabled} className={styles.Input} type="radio" name={name} value={value} onChange={onChange}/>
    <div className={labelClass} data-hj-suppress={personalData}>
      <span className={styles.Label}>{label}</span>
    </div>
  </label>
}

export interface RadioButtonGroupProperties {
  readonly showValidity?: boolean
  readonly validationResult: ValidationResult
}

export const RadioButtonGroup: React.FC<RadioButtonGroupProperties> = ({children, validationResult, showValidity = false}) => {
  return <div>
    <div className={styles.RadioButtonsContainer}>{children}</div>
    <div hidden={!showValidity || validationResult.valid}>
      <TextMessage color="crimson-red">{validationResult.errorMessage}</TextMessage>
    </div>
  </div>
}
